module.exports = __webpack_public_path__ + "img/bottom-icon2.4b4153c6.png";